/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Asset } from './asset';

export interface GoldenTransferLink {
  id?: number;
  network?: string;
  contract?: string;
  accountId?: number;
  account?: Account;
  assetId?: number;
  asset?: Asset;
  address?: string;
  autoBook?: boolean;
  availableWithdraw?: boolean;
  active?: boolean;
  businessEntity?: GoldenTransferLink.BusinessEntityEnum;
}
export namespace GoldenTransferLink {
  export const BusinessEntityEnum = {
    Sandbox1: 'SANDBOX1',
    Sandbox2: 'SANDBOX2',
    Inc: 'INC',
    Bermuda: 'BERMUDA',
    Brazil: 'BRAZIL',
  } as const;
  export type BusinessEntityEnum = (typeof BusinessEntityEnum)[keyof typeof BusinessEntityEnum];
}
